import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import styled from "styled-components";
import { IconCheck } from "@bynder/icons";
import { token } from "./token.js";
import { useId } from "./useId.js";
import { useDropdownContext } from "./context3.js";
import { List } from "./List.js";
function ListItem({
  children,
  isDisabled,
  isChecked = false,
  onClick: onClickProp,
  role = "menuitem",
  rightElements,
  ...props
}) {
  const id = useId("dropdown-item");
  const {
    dispatch,
    ...dropdown
  } = useDropdownContext();
  const isHighlighted = dropdown.highlightedItemId === id;
  useEffect(() => {
    dispatch({
      type: "add-item",
      payload: {
        id,
        parentId: void 0,
        isDisabled,
        isSelected: isChecked
      }
    });
  });
  useEffect(() => {
    var _a;
    if (dropdown.hasSearch || dropdown.isKeepingFocusOnTrigger) {
      return;
    }
    if (isHighlighted) {
      (_a = document.querySelector("#" + id)) == null ? void 0 : _a.focus();
    }
  }, [dropdown.hasSearch, dropdown.isKeepingFocusOnTrigger, id, isHighlighted]);
  function onClick() {
    onClickProp == null ? void 0 : onClickProp();
    dropdown.close();
  }
  const checkmark = isChecked ? /* @__PURE__ */ jsx(IconCheck, {
    style: {
      color: token.gray800
    }
  }) : null;
  return /* @__PURE__ */ jsx(ItemWrapper, {
    onClick: (e) => e.stopPropagation(),
    children: /* @__PURE__ */ jsx(List.Item, {
      isSelected: isHighlighted,
      isDisabled,
      onClick,
      "aria-disabled": isDisabled,
      "aria-checked": role === "menuitemradio" || role === "option" ? isChecked : void 0,
      "aria-selected": dropdown.hasSearch || dropdown.isKeepingFocusOnTrigger ? isHighlighted : void 0,
      role,
      rightElements: rightElements ? /* @__PURE__ */ jsxs(Fragment, {
        children: [rightElements, checkmark]
      }) : checkmark,
      id,
      ...props,
      children
    })
  });
}
const ItemWrapper = styled.div.withConfig({
  displayName: "ItemWrapper",
  componentId: "sc-upc0k1-0"
})(["--ds-list-item-border-radius-override:0;--ds-list-item-focus-ring-override:none;padding:0 ", ";"], token.spacing4);
export {
  ListItem
};
//# sourceMappingURL=ListItem2.js.map
